<ng-template #bellTpl>
  <span class="relative inline-flex cursor-pointer" (click)="menuNotifications.toggle($event)">
    <i class="pi pi-bell" style="font-size: 1.15rem"></i>
    @if (notifications && notifications.length>0) {
      <span class="yb-bell-dot">{{notifications.length}}</span>
    }
  </span>
</ng-template>

<div class="flex align-items-center">
  @if (avatar) {
    <p-avatar class="mr-2 yb-topbar-avatar" shape="square" image="{{avatar}}">
    </p-avatar>
  }
  @if (!avatar) {
    <p-avatar class="mr-2 yb-topbar-avatar" shape="square" label="{{initials}}">
    </p-avatar>
  }

</div> <p-menu #menuNotifications [model]="itemsNotifications" [popup]="true" (onHide)="onHideMenu($event)"
appendTo="body"></p-menu>
